import { render, staticRenderFns } from "./chargeWeight.vue?vue&type=template&id=859046b2&"
import script from "./chargeWeight.vue?vue&type=script&lang=js&"
export * from "./chargeWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('859046b2')) {
      api.createRecord('859046b2', component.options)
    } else {
      api.reload('859046b2', component.options)
    }
    module.hot.accept("./chargeWeight.vue?vue&type=template&id=859046b2&", function () {
      api.rerender('859046b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/mbl/chargeWeight.vue"
export default component.exports